import * as THREE from "three";
import { const_var, params } from "../../redux/reducers/reducer";
import { cupolaEditValidation, cupolaValidation } from "../../utils/Validation";
import { setPriceForCupola } from "../../action";
import store from "../../redux/store";
import * as cuBuilding from "../../redux/reducers/building_pricing/pricingReducer.js";
import { formatTrussOptionsByGauge, getGaugeRoofCost } from "../building_pricing/buildingPricing.helper.js";
import { calculateLegsCount } from "../common/common.helper.js";

//  Cupola Component Logic
export const addCupola = async (cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName, position, isType) => {
	let validationVariables;
	if (isType == "editmode") {
		validationVariables = cupolaEditValidation(length);
		return;
	} else {
		validationVariables = cupolaValidation(length);
	}
	const isAdd = validationVariables.isAdd;
	const positionZ = validationVariables.positionZ;
	const minLimitZ = validationVariables.minLimitZ;
	const maxLimitZ = validationVariables.maxLimitZ;
	const cupolaCount = isType === "update" ? const_var.cupolaUniqueId : validationVariables.cupolaCount;
	const newArray = validationVariables.newArray;

	if (isAdd) {
		let tempArray = [...newArray];
		tempArray.push({
			name: "cupola" + cupolaCount,
			width,
			length,
			dimension,
			uniqueId: cupolaCount,
			userData: {
				cupolaTypeId: cupolaTypeId,
				compType: cupolaType,
				compName: cupolaName,
				editIconPos: new THREE.Vector3(0, 0, positionZ)
			},
			size: dimension,
			positionZ,
			minLimitZ,
			maxLimitZ,
			price
		});

		const_var.isCupolaAdded = false;
		const_var.cupolas = [...tempArray];

		const_var.cupolaUniqueId = cupolaCount;
		const_var.cupolaEntries.push({
			uniqueId: cupolaCount,
			cupolaName: cupolaName,
			cupolaType: cupolaType,
			name: cupolaName,
			uniqueId: cupolaCount,
			cupola_price: price,
			dimension: dimension,
			width: width,
			length: length,
			position: { positionZ, minLimitZ, maxLimitZ },
			cupolaId: cupolaTypeId
		});

		store.dispatch(setPriceForCupola(true, const_var.cupolaUniqueId));
	} else {
		const_var.isCupolaAdded = false;
		const_var.isShowAlert = true;
		const_var.alertUsedFor = "noSpaceToAddCupola";
		store.dispatch(setPriceForCupola(false));
	}
};
export const loadCupolaInEditMode = async (cupolaEntries, isOldQuotes, oldCupolasPrice, oldCupolasQty) => {
	let prom = Promise.resolve(undefined);
	if (cupolaEntries !== undefined && cupolaEntries.length > 0) {
		let prom = Promise.resolve();

		for (var i = 0; i < cupolaEntries.length; i++) {
			let length = cupolaEntries[i].length;
			let width = cupolaEntries[i].width;
			let cupolaType = cupolaEntries[i].cupolaType;
			let dimension = cupolaEntries[i].dimension;
			let cupola_price = cupolaEntries[i].cupola_price;
			let cupolaId = cupolaEntries[i].cupolaId;
			let cupolaName = cupolaEntries[i].cupolaName;
			let position = cupolaEntries[i].position;
			let mode = "editmode";
			const newfuncforCupola = (cupolaType, width, length, dimension, cupola_price, cupolaId, cupolaName, position, mode) => {
				prom = prom.then(async (res, rej) => {
					const ans = await addCupola(cupolaType, width, length, dimension, cupola_price, cupolaId, cupolaName, position, mode);
				});
			};

			newfuncforCupola(cupolaType, width, length, dimension, cupola_price, cupolaId, cupolaName, position, "editmode");
		}
	}

	if (isOldQuotes === "Yes") {
		let cupola, cupolaType, dimension, width, length, price, cupolaId, cupolaName;
		cupola = params.cupolaObj;
		cupolaId = cupola.id;
		dimension = cupola.structure;
		width = Number(dimension.split("x")[0]);
		length = Number(dimension.split("x")[1]);
		price = parseFloat(oldCupolasPrice) / Number(oldCupolasQty);
		cupolaType = "without_windows";
		cupolaName = "Without Windows";

		if (const_var.scene.getObjectByName("cupola1") == undefined) {
			await addCupola(cupolaType, width, length, dimension, price, cupolaId, cupolaName, const_var.cupolaPosition.cupola1Pos, "editmode");
		}

		if (params.cupolaQty == 2 || params.cupolaQty == 3) {
			if (const_var.scene.getObjectByName("cupola2") == undefined) {
				await addCupola(cupolaType, width, length, dimension, price, cupolaId, cupolaName, const_var.cupolaPosition.cupola2Pos, "editmode");
			}
		}

		if (params.cupolaQty == 3) {
			if (const_var.scene.getObjectByName("cupola3") == undefined) {
				await addCupola(cupolaType, width, length, dimension, price, cupolaId, cupolaName, const_var.cupolaPosition.cupola3Pos, "editmode");
			}
		}
	}
};
export const updataOrRemoveCupola = (uniqueId, cupolaType, Width, length, dimension, price, cupolaTypeId, cupolaName, position, isType, oldCupolaWidth) => {
	const_var.scene.remove(const_var.scene.getObjectByName("cupola" + uniqueId));

	for (let i = 0; i < const_var.cupolas.length; i++) {
		if (const_var.cupolas[i].uniqueId == uniqueId) {
			const_var.cupolas.splice(i, 1);
		}
	}

	const_var.cupolaEntries.map((cupola, index) => {
		if (cupola.uniqueId == uniqueId) {
			const_var.cupolaEntries.splice(index, 1);
		}
	});

	let filterCupola = const_var.cupolaForMove.filter((c) => c.parent.uniqueId == uniqueId);
	for (let ii = 0; ii <= filterCupola.length - 1; ii++) {
		if (filterCupola[ii].parent.uniqueId == uniqueId) {
			for (let jj = 0; jj <= const_var.cupolaForMove.length - 1; jj++) {
				if (const_var.cupolaForMove[jj].parent.uniqueId == uniqueId) {
					const_var.cupolaForMove.splice(jj, 1);
				}
			}
		}
	}
	cuBuilding.cP();
	if (Width) addCupola(cupolaType, Width, length, dimension, price, cupolaTypeId, cupolaName, position, isType);
};
export const handlCupolaPositionOnDimensionChange = (str) => {
	if (const_var.cupolaEntries.length > 0 && const_var.scene) {
		const cupolaEntries = JSON.parse(JSON.stringify(const_var.cupolaEntries));
		let mainPosArray = [],
			mainPos = 0,
			preCupolaWidth;
		for (let i = 0; i <= cupolaEntries.length - 1; i++) {
			let cupola = const_var.scene.getObjectByName(cupolaEntries[i].name);
			let zPosition = 0;
			if (str == "l") {
				let cupolaWidth = cupolaEntries[i].width;
				if (mainPos == 0) {
					zPosition = -params.p_d / 2 + (cupolaWidth / 2 + 1);
				} else {
					zPosition = Number(mainPosArray[mainPos - 1]) + (cupolaWidth / 2 + preCupolaWidth / 2 + 1);
				}
				if (zPosition + cupolaWidth / 2 + 1 >= params.p_d / 2) {
					updataOrRemoveCupola(cupolaEntries[i].uniqueId);
					continue;
				}
				if (cupola != undefined) {
					cupola.position.set(cupola.position.x, cupola.position.y, zPosition);
					mainPosArray[mainPos] = zPosition;
					mainPos++;
					preCupolaWidth = cupolaWidth;
				}
			} else {
				if (cupola != undefined) {
					cupola.position.set(-params.p_w / 2 - 0.1, cupola.position.y, cupola.position.z);
				}
			}
		}
	}
};

export const removeAllCupolas = () => {
	if (const_var.cupolaEntries.length > 0) {
		const_var.cupolaEntries.map((cupola) => const_var.scene.remove(const_var.scene.getObjectByName(cupola.name)));
		const_var.cupolaEntries = [];
		const_var.cupolaForMove = [];
		const_var.cupolas = [];
		const_var.showCupolaEditBox = false;
		params.cupola = false;
		cuBuilding.cP();
	}
};
export const calcOverhangSize = (overhangVar) => {
	let isInch = overhangVar?.includes(`"`) || overhangVar?.includes(`''`);
	let size = 0.5;
	if (overhangVar) {
		if (isInch) {
			size = overhangVar.split(`"`) || overhangVar.split(`''`);

			if (params.m_s_n == 153) {
				size = "1";
			} else {
				if (overhangVar.includes(`'`) && !overhangVar.includes(`"`) && !overhangVar.includes(`''`)) {
					let inch = size.split(`'`)[1];
					inch = parseInt(inch) / 12;
					size = overhangVar.split(`'`)[0] + inch;
				} else {
					size = parseFloat(size) / 12;
				}
			}
		} else {
			size = overhangVar.split(`'`);
			size = size[0];
		}
	}
	return parseFloat(size) < 0.5 ? 0.5 : size;
};
export const updateCupolasArray = (state, action) => {
	const tempArr = [...action.newArray];
	state.const_var.cupolas = tempArr;
	let newCupolaArra = [];
	if (state.const_var.cupolas) {
		state.const_var.cupolas.map((item, index) => {
			let findIndex = const_var.cupolaEntries.findIndex((data) => data.uniqueId == item.uniqueId);
			if (findIndex !== -1) {
				newCupolaArra.push(const_var.cupolaEntries[findIndex]);
			}
		});
	}
	if (newCupolaArra.length == state.const_var.cupolas.length) {
		const_var.cupolaEntries = newCupolaArra;
	}

	return {
		...state,
		action
	};
};
export const updateCupolasData = (state, action) => {
	const tempArray = [...const_var.cupolas];
	const cupolaIndex = tempArray.findIndex((item) => item.uniqueId === action.uniqueId);
	if (cupolaIndex !== -1) {
		tempArray[cupolaIndex].positionZ = action.positionZ;
		state.const_var.cupolas = tempArray;
	}
	const cupolaEntries = [...const_var.cupolaEntries];
	const cupolaEntriesIndex = cupolaEntries.findIndex((item) => item.uniqueId === action.uniqueId);
	if (cupolaEntriesIndex !== -1 && cupolaEntries[cupolaEntriesIndex].position != undefined) {
		cupolaEntries[cupolaEntriesIndex].position.positionZ = action.positionZ;
		state.const_var.cupolaEntries = cupolaEntries;
	}

	return {
		...state,
		action
	};
};
export const handleCupolaData = (state, action) => {
	let cupola, cupolaType, dimension, width, length, price, cupolaTypeId, position, cupolaName;
	let prom = Promise.resolve(undefined);
	if (action.option === "add") {
		params.cupola = true;
		const_var.isCupolaAdded = true;
		cupola = const_var.cupolasData[action.value][0];
		cupolaType = cupola.slug;
		cupolaName = cupola.name;
		cupolaTypeId = cupola.id;
		dimension = cupola.structure;
		width = Number(dimension.split("x")[0]);
		length = Number(dimension.split("x")[1]);
		price = cupola.cost;

		const add_Cupola = (cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName) => {
			prom = prom.then(async (res, rej) => {
				const ans = await addCupola(cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName);
			});
		};
		add_Cupola(cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName);
	} else if (action.option === "update") {
		cupolaType = action.cupola.userData.compType;
		cupolaName = action.cupola.userData.compName;
		cupola = const_var.cupolasData[cupolaType].find((cupola) => cupola.id === parseFloat(action.value));
		position = action.cupola.positionZ;
		cupolaTypeId = action.value;
		dimension = cupola.structure;
		width = Number(dimension.split("x")[0]);
		length = Number(dimension.split("x")[1]);
		price = cupola.cost;
		let mode = "update";
		let cupola_width = action.cupola.width;
		let cupolaUniqueId = const_var.cupolaUniqueId;

		const filterCupolaArr = const_var.cupolas.filter((item) => item.uniqueId !== cupolaUniqueId);
		const { isEdit, isChangePos } = cupolaEditValidation(cupolaUniqueId, length, filterCupolaArr, position);
		if (isEdit) {
			const update_Cupola = (cupolaUniqueId, cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName, position, mode, cupola_width) => {
				prom = prom.then(async (res, rej) => {
					const ans = await updataOrRemoveCupola(cupolaUniqueId, cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName, position, mode, cupola_width);
				});
			};
			update_Cupola(cupolaUniqueId, cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName, position, mode, cupola_width);

			state.cupolaEditIconsPos = [];
			const_var.showCupolaEditBox = false;
		} else {
			const_var.showCupolaEditBox = false;
			const_var.isShowAlert = true;
			const_var.alertUsedFor = "noSpaceToUpdateCupola";
		}
	} else if (action.option === "clone") {
		params.cupola = true;
		const_var.isCupolaAdded = true;
		cupola = action.cupola;
		cupolaType = cupola.userData.compType;
		cupolaName = cupola.userData.compName;
		cupolaTypeId = cupola.userData.cupolaTypeId;
		dimension = cupola.dimension;
		width = Number(dimension.split("x")[0]);
		length = Number(dimension.split("x")[1]);
		price = cupola.price;
		const add_Cupola = (cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName) => {
			prom = prom.then(async (res, rej) => {
				const ans = await addCupola(cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName);
			});
		};
		add_Cupola(cupolaType, width, length, dimension, price, cupolaTypeId, cupolaName);
		const_var.showCupolaEditBox = false;
		const_var.showCupolaEditBox = false;
	} else if (action.option === "remove") {
		if (action.cupola == "fromOptionTab") {
			let id = "";
			if (const_var.cupolaEntries != undefined && const_var.cupolaEntries.length > 0) {
				if (action.value == "with_windows") {
					id = const_var.cupolaEntries.find((item) => item.cupolaType == "with_windows")?.uniqueId;
				}
				if (action.value == "without_windows") {
					id = const_var.cupolaEntries.find((item) => item.cupolaType == "without_windows")?.uniqueId;
				}
			}
			updataOrRemoveCupola(id, "", "", "", "", "", "", "", "", "remove");
			state.cupolaEditIconsPos = [];
		} else {
			const_var.cupolaUniqueId = action.uniqueId;
			const_var.showCupolaEditBox = false;
			state.isShowEditIconSection = false;
			updataOrRemoveCupola(const_var.cupolaUniqueId, "", "", "", "", "", "", "", "", "remove");
			state.cupolaEditIconsPos = [];
		}
	} else if (action.option === "close") {
		const_var.showCupolaEditBox = false;
		state.cupolaEditIconsPos = [];
	} else if (action.option === "type") {
		const_var.cupolaType = action.value;
	} else if (action.option === "cupolaRoofColor") {
		params.c_r_c = action.value.hex_value.replace("#", "0x");
		let cupola = const_var.cupolaEntries.find((cupola) => cupola.uniqueId === action.uniqueId);
		if (cupola) {
			cupola.cupola_roof_color_price = action.value.cost;
			const_var.cupola_roof_color_price = action.value.cost;
		}
	}
	const_var.UpdatedPriceData.wainscot_price_changed = true;

	const_var.UpdatedPriceData.surcharge_amount = undefined;
	return {
		...state,
		newColor: action.option + cupola + cupolaType + dimension + width + length + price + cupolaTypeId + position + cupolaName,
		action
	};
};
export const gaugeActionData = (state, action, utils) => {
	state.params.gauge_val_check = !state.params.gauge_val_check;
	if (state.params.gauge_val_check == true) {
		state.params.gauge_val = 12;
	} else {
		state.params.gauge_val = 14;
	}
	const_var.CallApionAction = true;
	state.const_var.g_v = state.params.gauge_val;
	const cost = getGaugeRoofCost(const_var.a_p_d_a?.base, state.params.p_r_s, state.params.gauge_val);
	const_var.showGaugePriceVal = utils.convertToTwoDecimalNumber(cost);
	const_var.a_p_d_a.truss_name = formatTrussOptionsByGauge(const_var.NewTrussOption, state.params.gauge_val);
	if (const_var.UpdatedPriceData.gauge != state.params.gauge_val) {
		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;

		if (const_var.b_r_p_a[params.b_r_p] != undefined && const_var.b_r_p_a[params.b_r_p].cost_type == "%") {
			const_var.UpdatedPriceData.roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.left_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.right_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.front_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.back_lean_roof_pitch_price_changed = true;
			const_var.UpdatedPriceData.surcharge_amount = undefined;
		}
	}
	let newCheckforAPI = false;
	let a_p_d_ab = const_var.isLTBuilding ? const_var.holdPricingResponse : const_var.a_p_d_a;
	if (a_p_d_ab != undefined) {
		let temp_a_p_d_ab_side = JSON.parse(JSON.stringify(a_p_d_ab?.side));
		for (let key in action.apiResponseData.center.data) {
			a_p_d_ab[key] = action.apiResponseData.center.data[key];
			newCheckforAPI = true;
		}
		if (a_p_d_ab?.side?.length > 0 && temp_a_p_d_ab_side?.length > 0) {
			let item = a_p_d_ab?.side[0];
			item.lift_type = temp_a_p_d_ab_side[0].lift_type;
			item.lifttype_price = temp_a_p_d_ab_side[0].lifttype_price;
		}
		if (params.add_left_lean == true) {
			newCheckforAPI = false;
			for (let key in action.apiResponseData.left.data) {
				const_var.leanGetDataLeft[key] = action.apiResponseData.left.data[key];
				newCheckforAPI = true;
			}
			if (const_var.leanGetDataLeft.central_side != undefined && const_var.leanGetDataLeft.central_side.length > 0) {
				a_p_d_ab.side = const_var.leanGetDataLeft.central_side;
			}
			if (const_var.leanGetDataLeft.central_side_full_length != undefined && const_var.leanGetDataLeft.central_side_full_length.length > 0) {
				a_p_d_ab.full_length_side = const_var.leanGetDataLeft.central_side_full_length;
			}
			if (const_var.leanGetDataLeft.central_insulation != undefined && const_var.leanGetDataLeft.central_insulation.length > 0) {
				const_var.cbInsulation = const_var.leanGetDataLeft.central_insulation;
			}
			if (const_var.leanGetDataLeft.central_end != undefined && const_var.leanGetDataLeft.central_end.length > 0) {
				a_p_d_ab.end = const_var.leanGetDataLeft.central_end;
			}
			if (const_var.leanGetDataLeft.central_utility_side != undefined && const_var.leanGetDataLeft.central_utility_side.length > 0) {
				a_p_d_ab.utility_side = const_var.leanGetDataLeft.central_utility_side;
			}
			if (const_var.leanGetDataLeft.end_combo_v3 != undefined && const_var.leanGetDataLeft.end_combo_v3.length > 0) {
				a_p_d_ab.end_combo_v3 = const_var.leanGetDataLeft.end_combo_v3;
			}
			if (const_var.leanGetDataLeft.side_combo_v3 != undefined && const_var.leanGetDataLeft.side_combo_v3.length > 0) {
				a_p_d_ab.side_combo_v3 = const_var.leanGetDataLeft.side_combo_v3;
			}
			if (const_var.leanGetDataLeft.central_trusses != undefined && const_var.leanGetDataLeft.central_trusses.length > 0) {
				a_p_d_ab.trusses = const_var.leanGetDataLeft.central_trusses;
			}
			utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataLeft", "left");
		}
		if (params.add_right_lean == true) {
			newCheckforAPI = false;
			for (let key in action.apiResponseData.right.data) {
				const_var.leanGetDataRight[key] = action.apiResponseData.right.data[key];
				newCheckforAPI = true;
			}
			if (const_var.leanGetDataRight.central_side != undefined && const_var.leanGetDataRight.central_side.length > 0) {
				a_p_d_ab.side = const_var.leanGetDataRight.central_side;
			}
			if (const_var.leanGetDataRight.central_insulation != undefined && const_var.leanGetDataRight.central_insulation.length > 0) {
				const_var.cbInsulation = const_var.leanGetDataRight.central_insulation;
			}
			if (const_var.leanGetDataRight.central_side_full_length != undefined && const_var.leanGetDataRight.central_side_full_length.length > 0) {
				a_p_d_ab.full_length_side = const_var.leanGetDataRight.central_side_full_length;
			}
			if (const_var.leanGetDataRight.central_end != undefined && const_var.leanGetDataRight.central_end.length > 0) {
				a_p_d_ab.end = const_var.leanGetDataRight.central_end;
			}
			if (const_var.leanGetDataRight.central_utility_side != undefined && const_var.leanGetDataRight.central_utility_side.length > 0) {
				a_p_d_ab.utility_side = const_var.leanGetDataRight.central_utility_side;
			}
			if (const_var.leanGetDataRight.end_combo_v3 != undefined && const_var.leanGetDataRight.end_combo_v3.length > 0) {
				a_p_d_ab.end_combo_v3 = const_var.leanGetDataRight.end_combo_v3;
			}
			if (const_var.leanGetDataRight.side_combo_v3 != undefined && const_var.leanGetDataRight.side_combo_v3.length > 0) {
				a_p_d_ab.side_combo_v3 = const_var.leanGetDataRight.side_combo_v3;
			}
			if (const_var.leanGetDataRight.central_trusses != undefined && const_var.leanGetDataRight.central_trusses.length > 0) {
				a_p_d_ab.trusses = const_var.leanGetDataRight.central_trusses;
			}
			utils.updateCenterBuildingPricesOnLeanAPICalls(state, "leanGetDataRight", "right");
		}
		if (params.add_front_lean == true) {
			newCheckforAPI = false;
			for (let key in action.apiResponseData.front.data) {
				const_var.leanGetDataFront[key] = action.apiResponseData.front.data[key];
				newCheckforAPI = true;
			}
			if (const_var.leanGetDataFront.central_side != undefined && const_var.leanGetDataFront.central_side.length > 0) {
				a_p_d_ab.side = const_var.leanGetDataFront.central_side;
			}
			if (const_var.leanGetDataFront.central_side_full_length != undefined && const_var.leanGetDataFront.central_side_full_length.length > 0) {
				a_p_d_ab.full_length_side = const_var.leanGetDataFront.central_side_full_length;
			}
			if (const_var.leanGetDataFront.central_insulation != undefined && const_var.leanGetDataFront.central_insulation.length > 0) {
				const_var.cbInsulation = const_var.leanGetDataFront.central_insulation;
			}
			if (const_var.leanGetDataFront.central_end != undefined && const_var.leanGetDataFront.central_end.length > 0) {
				a_p_d_ab.end = const_var.leanGetDataFront.central_end;
			}
			if (const_var.leanGetDataFront.central_utility_side != undefined && const_var.leanGetDataFront.central_utility_side.length > 0) {
				a_p_d_ab.utility_side = const_var.leanGetDataFront.central_utility_side;
			}
			if (const_var.leanGetDataFront.end_combo_v3 != undefined && const_var.leanGetDataFront.end_combo_v3.length > 0) {
				a_p_d_ab.end_combo_v3 = const_var.leanGetDataFront.end_combo_v3;
			}
			if (const_var.leanGetDataFront.side_combo_v3 != undefined && const_var.leanGetDataFront.side_combo_v3.length > 0) {
				a_p_d_ab.side_combo_v3 = const_var.leanGetDataFront.side_combo_v3;
			}
			if (const_var.leanGetDataFront.central_trusses != undefined && const_var.leanGetDataFront.central_trusses.length > 0) {
				a_p_d_ab.trusses = const_var.leanGetDataFront.central_trusses;
			}
		}
		if (params.add_back_lean == true) {
			newCheckforAPI = false;
			for (let key in action.apiResponseData.back.data) {
				const_var.leanGetDataBack[key] = action.apiResponseData.back.data[key];
				newCheckforAPI = true;
			}
			if (const_var.leanGetDataBack.central_side != undefined && const_var.leanGetDataBack.central_side.length > 0) {
				a_p_d_ab.side = const_var.leanGetDataBack.central_side;
			}
			if (const_var.leanGetDataBack.central_side_full_length != undefined && const_var.leanGetDataBack.central_side_full_length.length > 0) {
				a_p_d_ab.full_length_side = const_var.leanGetDataBack.central_side_full_length;
			}
			if (const_var.leanGetDataBack.central_insulation != undefined && const_var.leanGetDataBack.central_insulation.length > 0) {
				const_var.cbInsulation = const_var.leanGetDataBack.central_insulation;
			}
			if (const_var.leanGetDataBack.central_end != undefined && const_var.leanGetDataBack.central_end.length > 0) {
				a_p_d_ab.end = const_var.leanGetDataBack.central_end;
			}
			if (const_var.leanGetDataBack.central_utility_side != undefined && const_var.leanGetDataBack.central_utility_side.length > 0) {
				a_p_d_ab.utility_side = const_var.leanGetDataBack.central_utility_side;
			}
			if (const_var.leanGetDataBack.end_combo_v3 != undefined && const_var.leanGetDataBack.end_combo_v3.length > 0) {
				a_p_d_ab.end_combo_v3 = const_var.leanGetDataBack.end_combo_v3;
			}
			if (const_var.leanGetDataBack.side_combo_v3 != undefined && const_var.leanGetDataBack.side_combo_v3.length > 0) {
				a_p_d_ab.side_combo_v3 = const_var.leanGetDataBack.side_combo_v3;
			}
			if (const_var.leanGetDataBack.central_trusses != undefined && const_var.leanGetDataBack.central_trusses.length > 0) {
				a_p_d_ab.trusses = const_var.leanGetDataBack.central_trusses;
			}
		}
		const isBuildingOnFourFeetOnCenter = params.fourth_center_cost;
		const isBuildingOnFourFeetOnCenterLegs = const_var.DistanceArr[params.p_b_t][params.p_r_s];
		cuBuilding.makeCertificateArray("gauge");

		if (isBuildingOnFourFeetOnCenter != params.fourth_center_cost && isBuildingOnFourFeetOnCenterLegs != const_var.DistanceArr[params.p_b_t][params.p_r_s]) {
			cuBuilding.BuildingUpdate(true, "");
			if (params.add_front_lean) cuBuilding.UpdateFrontLean();
			if (params.add_left_lean) cuBuilding.UpdateLeftLean();
			if (params.add_right_lean) cuBuilding.UpdateRightLean();
			if (params.add_back_lean) cuBuilding.UpdateBackLean();
		}

		if (const_var.ExtraItemsFeaturesArray.length > 0 || params.fourth_center_cost) {
			calculateLegsCount();
		}
	}

	if (state.params.add_left_lean == true && newCheckforAPI == true) {
		const_var.UpdatedPriceData.left_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.left_lean_height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;

		cuBuilding.makeCertificateArrayLeft("left");
		if (params.fourth_center_cost == true) {
			if (params.add_left_lean) calculateLegsCount(const_var.leanGetDataLeft, "leftLean");
		}
		cuBuilding.cPforLLeanOnly(state.const_var.leanGetDataLeft);
		const_var.is_loader = false;
	}
	if (state.params.add_front_lean == true && newCheckforAPI == true) {
		const_var.UpdatedPriceData.front_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.front_lean_height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		if (params.fourth_center_cost == true) {
			if (params.add_front_lean) calculateLegsCount(const_var.leanGetDataFront, "frontLean");
		}
		cuBuilding.makeCertificateArrayLeft("front");
		cuBuilding.cPforFLeanOnly(state.const_var.leanGetDataFront);
		const_var.is_loader = false;
	}
	if (state.params.add_back_lean == true && newCheckforAPI == true) {
		const_var.UpdatedPriceData.back_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.back_lean_height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		if (params.fourth_center_cost == true) {
			if (params.add_back_lean) calculateLegsCount(const_var.leanGetDataBack, "backLean");
		}
		cuBuilding.makeCertificateArrayLeft("back");
		cuBuilding.cPforBLeanOnly(state.const_var.leanGetDataBack);
		const_var.is_loader = false;
	}
	if (state.params.add_right_lean == true && newCheckforAPI == true) {
		const_var.UpdatedPriceData.right_lean_roof_style_price_changed = true;
		const_var.UpdatedPriceData.right_lean_height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		if (params.fourth_center_cost == true) {
			if (params.add_right_lean) calculateLegsCount(const_var.leanGetDataRight, "rightLean");
		}
		cuBuilding.makeCertificateArrayLeft("right");
		cuBuilding.cPforRLeanOnly(state.const_var.leanGetDataRight);
		const_var.is_loader = false;
	}
	if (state.params.add_right_lean == false && state.params.add_left_lean == false && newCheckforAPI == true) {
		const_var.UpdatedPriceData.roof_style_price_changed = true;
		const_var.UpdatedPriceData.height_price_changed = true;
		const_var.UpdatedPriceData.certificate_price_changed = true;
		cuBuilding.cP();
		const_var.is_loader = false;
	}

	return {
		...state,
		newColor: state.params.gauge_val_check + state.params.gauge_val + const_var.is_loader
	};
};
export const updateBracingSelection = (isFor) => {
	if (isFor == "center") {
		if (params.p_s_c_b == true) {
			if (const_var.a_p_d_a.side_cross_bracing?.length > 0) {
				let isBracingExist = const_var.a_p_d_a.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selected_scbracing);
				let defaultSelected = const_var.a_p_d_a.side_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selected_scbracing = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.p_s_c_b = const_var.selected_scbracing != "" && const_var.selected_scbracing != "none" ? true : false;
			} else {
				params.p_s_c_b = false;
				const_var.selected_scbracing = "";
			}
		}
		if (params.p_e_c_b == true) {
			if (const_var.a_p_d_a.end_cross_bracing?.length > 0) {
				let isBracingExist = const_var.a_p_d_a.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selected_ecbracing);
				let defaultSelected = const_var.a_p_d_a.end_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selected_ecbracing = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.p_e_c_b = const_var.selected_ecbracing != "" && const_var.selected_ecbracing != "none" ? true : false;
			} else {
				params.p_e_c_b = false;
				const_var.selected_ecbracing = "";
			}
		}
	}
	if (isFor == "left") {
		if (params.added_building_bracing.p_s_c_b_l == true) {
			if (const_var.leanGetDataLeft.side_cross_bracing?.length > 0) {
				let isBracingExist = const_var.leanGetDataLeft.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.left_lean_side);
				let defaultSelected = const_var.leanGetDataLeft.side_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selectedBracingForAddedBuilding.left_lean_side = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.added_building_bracing.p_s_c_b_l = const_var.selectedBracingForAddedBuilding.left_lean_side != "" && const_var.selectedBracingForAddedBuilding.left_lean_side != "none" ? true : false;
			} else {
				params.added_building_bracing.p_s_c_b_l = false;
				const_var.selectedBracingForAddedBuilding.left_lean_side = "";
			}
		}
		if (params.added_building_bracing.p_e_c_b_l == true) {
			if (const_var.leanGetDataLeft.end_cross_bracing?.length > 0) {
				let isBracingExist = const_var.leanGetDataLeft.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.left_lean_end);
				let defaultSelected = const_var.leanGetDataLeft.end_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selectedBracingForAddedBuilding.left_lean_end = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.added_building_bracing.p_e_c_b_l = const_var.selectedBracingForAddedBuilding.left_lean_end != "" && const_var.selectedBracingForAddedBuilding.left_lean_end != "none" ? true : false;
			} else {
				params.added_building_bracing.p_e_c_b_l = false;
				const_var.selectedBracingForAddedBuilding.left_lean_end = "";
			}
		}
	}
	if (isFor == "right") {
		if (params.added_building_bracing.p_s_c_b_r == true) {
			if (const_var.leanGetDataRight.side_cross_bracing?.length > 0) {
				let isBracingExist = const_var.leanGetDataRight.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.right_lean_side);
				let defaultSelected = const_var.leanGetDataRight.side_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selectedBracingForAddedBuilding.right_lean_side = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.added_building_bracing.p_s_c_b_r = const_var.selectedBracingForAddedBuilding.right_lean_side != "" && const_var.selectedBracingForAddedBuilding.right_lean_side != "none" ? true : false;
			} else {
				params.added_building_bracing.p_s_c_b_r = false;
				const_var.selectedBracingForAddedBuilding.right_lean_side = "";
			}
		}
		if (params.added_building_bracing.p_e_c_b_r == true) {
			if (const_var.leanGetDataRight.end_cross_bracing?.length > 0) {
				let isBracingExist = const_var.leanGetDataRight.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.right_lean_end);
				let defaultSelected = const_var.leanGetDataRight.end_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selectedBracingForAddedBuilding.right_lean_end = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.added_building_bracing.p_e_c_b_r = const_var.selectedBracingForAddedBuilding.right_lean_end != "" && const_var.selectedBracingForAddedBuilding.right_lean_end != "none" ? true : false;
			} else {
				params.added_building_bracing.p_e_c_b_r = false;
				const_var.selectedBracingForAddedBuilding.right_lean_end = "";
			}
		}
	}
	if (isFor == "front") {
		if (params.added_building_bracing.p_s_c_b_f == true) {
			if (const_var.leanGetDataFront.side_cross_bracing?.length > 0) {
				let isBracingExist = const_var.leanGetDataFront.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.front_lean_side);
				let defaultSelected = const_var.leanGetDataFront.side_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selectedBracingForAddedBuilding.front_lean_side = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.added_building_bracing.p_s_c_b_f = const_var.selectedBracingForAddedBuilding.front_lean_side != "" && const_var.selectedBracingForAddedBuilding.front_lean_side != "none" ? true : false;
			} else {
				params.added_building_bracing.p_s_c_b_f = false;
				const_var.selectedBracingForAddedBuilding.front_lean_side = "";
			}
		}
		if (params.added_building_bracing.p_e_c_b_f == true) {
			if (const_var.leanGetDataFront.end_cross_bracing?.length > 0) {
				let isBracingExist = const_var.leanGetDataFront.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.front_lean_end);
				let defaultSelected = const_var.leanGetDataFront.end_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selectedBracingForAddedBuilding.front_lean_end = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.added_building_bracing.p_e_c_b_f = const_var.selectedBracingForAddedBuilding.front_lean_end != "" && const_var.selectedBracingForAddedBuilding.front_lean_end != "none" ? true : false;
			} else {
				params.added_building_bracing.p_e_c_b_f = false;
				const_var.selectedBracingForAddedBuilding.front_lean_end = "";
			}
		}
	}
	if (isFor == "back") {
		if (params.added_building_bracing.p_s_c_b_b == true) {
			if (const_var.leanGetDataBack.side_cross_bracing?.length > 0) {
				let isBracingExist = const_var.leanGetDataBack.side_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.back_lean_side);
				let defaultSelected = const_var.leanGetDataBack.side_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selectedBracingForAddedBuilding.back_lean_side = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.added_building_bracing.p_s_c_b_b = const_var.selectedBracingForAddedBuilding.back_lean_side != "" && const_var.selectedBracingForAddedBuilding.back_lean_side != "none" ? true : false;
			} else {
				params.added_building_bracing.p_s_c_b_b = false;
				const_var.selectedBracingForAddedBuilding.back_lean_side = "";
			}
		}
		if (params.added_building_bracing.p_e_c_b_b == true) {
			if (const_var.leanGetDataBack.end_cross_bracing?.length > 0) {
				let isBracingExist = const_var.leanGetDataBack.end_cross_bracing?.find((obj) => obj.sheet_name == const_var.selectedBracingForAddedBuilding.back_lean_end);
				let defaultSelected = const_var.leanGetDataBack.end_cross_bracing.find((obj) => obj.is_default == "included");
				const_var.selectedBracingForAddedBuilding.back_lean_end = isBracingExist ? isBracingExist.sheet_name : defaultSelected ? defaultSelected.sheet_name : "";
				params.added_building_bracing.p_e_c_b_b = const_var.selectedBracingForAddedBuilding.back_lean_end != "" && const_var.selectedBracingForAddedBuilding.back_lean_end != "none" ? true : false;
			} else {
				params.added_building_bracing.p_e_c_b_b = false;
				const_var.selectedBracingForAddedBuilding.back_lean_end = "";
			}
		}
	}
};
